import React, { useState, useEffect } from 'react';
import language from '../../../utils/LanguageSettings';
import RenderSnA from '../../functions/renderSnA';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import gfm from 'remark-gfm';
import { fetchAdvertiser } from '../../functions/fetchAdvertiser';
import { SOURCE_URL } from '../../../config';
import { useInView } from 'react-intersection-observer';
import 'animate.css';
import { animationClass, animationStyle } from '../../../utils/FadeInEffect';

interface AdvertiserTextLayoutProps {
    element: any
}

const AdvertiserTextLayout: React.FC<AdvertiserTextLayoutProps> = (element) => {
    const { ref, inView } = useInView({
        threshold: 0.1,
        triggerOnce: true,
    });
    
    return (
      <>
        <div ref={ref} className={`col-lg-6 columned-item mb-4 text-center ${animationClass(inView, 'up')}`}  style={animationStyle(inView,'up')} >
            <div className="h-100 advertisement-column hid-overflow mb-5">
                <div className="img-wrap aspect-ratio advertiser-img">
                    <img className="img-fit lazyloaded" src={SOURCE_URL + element?.element?.ContentImage?.data?.attributes?.url} />
                    <noscript><img src={SOURCE_URL + element?.element?.ContentImage?.data?.attributes?.url} className='img-fit'/></noscript>
                </div>
                <h5 className="font-weight-bold py-4 my-3 px-3">{element?.element?.ContentTitle}</h5>
                <div className="content-text-box">
                    <div className="content-text barlow-font text-left d-flex justify-content-center">
                        <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{element?.element?.ContentText}</ReactMarkdown>
                    </div>
                </div>
            </div>
        </div>
      </>
    );
};

export default AdvertiserTextLayout;